// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"AddToShoppingListButton_wrapperComponent__2NNrs","shoppingListButton":"AddToShoppingListButton_shoppingListButton__q0lq-"};